import type { GroupWithMembers, TopCondition } from "../types";

/** Top N conditions by total non-excluded debits with the members carrying them (product plan 6.4). */
export function topConditions(group: GroupWithMembers, take: number): TopCondition[] {
  const byCondition = new Map<number, TopCondition>();
  for (const member of group.members) {
    if (member.isExcluded) continue;
    for (const rating of member.assignedRatings) {
      if (rating.isExcluded) continue;
      const existing = byCondition.get(rating.conditionId) ?? { conditionId: rating.conditionId, conditionName: rating.conditionName, totalDebits: 0, members: [] };
      const fullName = `${member.firstName} ${member.lastName}`.trim();
      const members = existing.members.some((entry) => entry.memberId === member.id) ? existing.members : [...existing.members, { memberId: member.id, fullName }];
      byCondition.set(rating.conditionId, { ...existing, totalDebits: existing.totalDebits + rating.assignedDebits, members });
    }
  }
  return [...byCondition.values()].sort((a, b) => b.totalDebits - a.totalDebits || a.conditionName.localeCompare(b.conditionName)).slice(0, take);
}
